import { Icon, SvgForward5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch, useSelector } from 'react-redux';

import { ROLLOUT_WEAVE, VARIANT } from 'constants/featureFlag';
import { V6 } from 'constants/recordingVersions';
import { PLAYER_LONG_STEP } from 'constants/videoPlayer';
import { skipForward, skipForwardEditMode } from 'creators/videoPlayer';
import { selectInTrimMode } from 'selectors/shareVideo';
import { selectVideoProperties } from 'selectors/video';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import ControlBarButton from '../control-bar-button';

import { useClipsState } from 'components/share-video/edit-tools/clips/state';

import './styles.less';

export default function StepForwardFiveButton(props) {
  const dispatch = useDispatch();
  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);
  const inTrimMode = useSelector(selectInTrimMode);
  const videoProperties = useSelector(selectVideoProperties);
  const { recording_version } = videoProperties;

  const clipsState = useClipsState(state => ({
    clips: state.clips,
    focusedClipIndex: state.focusedClipIndex,
    updateFocusedClipIndex: state.updateFocusedClipIndex,
    updateFocusedPlayRangeIndex: state.updateFocusedPlayRangeIndex,
  }));

  const handleHotkeys = () => {
    !inTrimMode && dispatch(skipForward());
  };

  const handleOnClick = () => {
    if (inTrimMode && rolloutWeave && recording_version !== V6) {
      dispatch(skipForward());
    } else if (inTrimMode && rolloutWeave) {
      dispatch(skipForwardEditMode(PLAYER_LONG_STEP, clipsState));
    } else {
      dispatch(skipForward());
    }
  };

  useHotkeys('l, right', handleHotkeys, [inTrimMode]);

  return (
    <ControlBarButton
      className={classNames('step-forward-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Forward (l)"
      seeking={props.seeking}
      onClick={handleOnClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgForward5 />}
      />
    </ControlBarButton>
  );
}
